export default __webpack_public_path__ + "media/images/file_types/png-602dad01c19f0060f56bce8e56ccbbee.svg";